import { formAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle, } from '@chakra-ui/styled-system';
import { ThemeColorToken, ThemeFontSizeToken, ThemeFontToken, ThemeSpaceToken, } from '../theme-tokens';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const baseStyleRequiredIndicator = defineStyle({
    color: ThemeColorToken.Error,
});
const baseStyleHelperText = defineStyle({
    color: ThemeColorToken.OnBackgroundSubdued,
    fontSize: ThemeFontSizeToken.Small,
    marginTop: ThemeSpaceToken.XSmall,
});
const baseStyle = definePartsStyle({
    container: {
        _disabled: {
            opacity: 1,
            color: ThemeColorToken.OnBackgroundSubdued,
        },
        fontFamily: ThemeFontToken.Body,
        fontSize: ThemeFontSizeToken.Medium,
        color: ThemeColorToken.OnBackground,
    },
    requiredIndicator: baseStyleRequiredIndicator,
    helperText: baseStyleHelperText,
});
export const formConfig = defineMultiStyleConfig({
    baseStyle,
});
//# sourceMappingURL=form-theme.js.map